import {
  EventTypes,
  NavigationEvents,
  track,
  Pages,
  PageSource,
  Locations,
  Product,
  Actions,
  segment,
  trackGoldStandardEvent,
  getPageSource,
} from '@mc/track-event'

/**
 * Page sources
 */

export const PAGE_SOURCES = {
  HOMEPAGE: PageSource.HOMEPAGE,
  CM_PAGE: PageSource.CLASS_PAGE,
  SERIES_PAGE: PageSource.SERIES_PAGE,
  ARTICLES_PAGE: PageSource.ARTICLES,
  ARTICLE_PAGE: PageSource.ARTICLE,
  CATEGORY_PAGE: PageSource.CATEGORY,
  EPISODE_PAGE: PageSource.EPISODE_PAGE,
  OUTCOME: PageSource.OUTCOME,
  PREPW_PLANS: PageSource.PLANS, // "Plans"
  POSTPW_PLANS: 'Logged-in Plans', // differentiate pre/post-pw
  SESS_MKTG_PAGE: Pages.SESSION_COURSE_MARKETING_PAGE,
  SESS_HUB_PAGE: Pages.SESSIONS_HUB_PAGE,
  PROMOTION_PAGE: Pages.PROMOTION_PAGE,
  SUBCATEGORY: PageSource.SUBCATEGORY,
} as const

export type PageSource = (typeof PAGE_SOURCES)[keyof typeof PAGE_SOURCES]

/**
 * Promo events
 */

export const trackCtaClicked = ({
  action,
  location,
  pageSource = PageSource.PROMOTION_PAGE,
  href,
}: {
  action: string
  location: string
  pageSource?: string
  href: string
}) => {
  track(EventTypes.PURCHASE_CLICK, {
    location,
    action,
    page_source: pageSource,
    href,
  })
}

// promo banner

export const LOCATION = 'promotion-banner'

export const trackBannerOnClose = () =>
  trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    page_source: getPageSource(),
    location: LOCATION,
    action: 'close',
  })

export const trackBannerCTAClick = ({
  action,
  href,
}: {
  action: string
  href: string
}) => {
  trackGoldStandardEvent(segment.NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    page_source: getPageSource(),
    location: LOCATION,
    action,
    category: 'details',
    href,
  })
}

export const trackExplainerModalViewed = ({
  pageSource,
}: {
  pageSource: string
}) =>
  track(EventTypes.MODAL_VIEWED, {
    subscription_id: {},
    active_annual_pass: false,
    category: 'details',
    location: Locations.PROMOTION_MODAL,
    modal_type: 'seasonal_promotion',
    page_source: pageSource,
    product: Product.MASTERCLASS,
    url_referrer: 'www.masterclass.com',
  })

export const trackNavigationClicked = () => {
  trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    subscription_id: {},
    active_annual_pass: false,
    location: Locations.PROMOTION_MODAL,
    action: Actions.CLOSE,
  })
}
